module.exports = __webpack_public_path__ + "static/img/14.84f70e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/14.png
// module id = BRBo
// module chunks = 0